<template>
    <div>
        <v-container>
            <v-card>        
                <v-card-text>
                    <v-row v-if="!vendor">
                        <v-col cols="3" class="yellow lighten-4 font-weight-bold">Upload File Pengumuman</v-col>              
                        <v-col cols="6" >
                            <v-file-input
                                label="File Pengumuman"
                                v-model="formFileUpload.uploadFilePengumuman"
                                :placeholder="formFileUpload.filePengumuman" 
                                accept=".jpg,.png,.pdf,.doc,.docx,.xls,.xlsx,.zip" 
                                append-icon="get_app" 
                                @click:append="tenderLib.getFileDownloadLink(formFileUpload.paketPenyediaId, `FileJadwalPrivate_${formFileUpload.urut}`, formFileUpload.filePengumuman, false)" 
                            >
                            </v-file-input>
                        </v-col>
                        <v-col cols="3" >
                            <v-btn color="green"  @click="submitFormFileUpload()">Upload</v-btn>
                        </v-col>
                    </v-row>
                    <v-row v-if="vendor ">
                        <v-col cols="3" class="yellow lighten-4 font-weight-bold">File Pengumuman</v-col>
                        <v-col v-if="formFileUpload.filePengumuman !== ''">
                            <v-btn icon @click="tenderLib.getFileDownloadLink(formFileUpload.paketPenyediaId, `FileJadwalPrivate_${formFileUpload.urut}`, formFileUpload.filePengumuman, false)"><v-icon color="green">get_app</v-icon></v-btn>
                            {{ formFileUpload.filePengumuman }}
                        </v-col>
                        <v-col v-else>
                            Admin belum upload file pengumuman.
                        </v-col>
                    </v-row>
                </v-card-text>
            </v-card>
        </v-container>
        <!-- Notification -->
        <v-snackbar
            v-model="notification.show"
            :color="notification.color"
            :top="true"
            :right="true"
            :timeout=3000
        >
            {{notification.text}}
        </v-snackbar>
    </div>
</template>
        
 <script>
const axios = require('axios').default;
const apiUrl = process.env.VUE_APP_ROOT_API;
import { TenderLib } from "./../../lib/tenderLib";

export default {

    props: {
        readonly: {
            type: Boolean,
            default: false
        },
        vendor: {
            type: Boolean,
            default: false
        },
        urut: {
            type: Number,
            default: 0
        },
    },

    data() {
        return {
            
            formFileUpload: {
                paketPenyediaId: null,
                paket: {
                    kode: null,
                    nama: null,
                    metodePemilihan: null,
                },
                urut: null,
                uploadFilePengumuman: null,
                filePengumuman: null,
                showVendor: 0
            },
            notification: {
                show: false,
                color: "success",
                text: ""
            },
            tenderLib: TenderLib
        }
    },
    
    computed: {
        paket() {
            return this.$store.getters['lelang/paket']
        },
        
        jadwal: function() {
        return this.$store.getters['lelang/jadwal']
        },
    },

    watch: {
        paket() {
            this.getData();
        }
    },

    mounted() {
        this.getData();
    },

    methods: {
        getData() {
            let jadwalUrut = this.jadwal.find(el => el.urut == this.urut);
            this.formFileUpload.paket.id = this.paket.id;
            this.formFileUpload.paket.kode = this.paket.kode;
            this.formFileUpload.paket.nama = this.paket.nama;
            this.formFileUpload.paket.metodePemilihan = this.paket.metodePemilihan;
            this.formFileUpload.paketPenyediaId = this.paket.id;
            this.formFileUpload.urut = this.urut;
            this.formFileUpload.filePengumuman = jadwalUrut.fileJadwalPrivate;
        },
        
        submitFormFileUpload() {
            let fdata = new FormData()
            fdata.append('paketPenyediaId', this.paket.id)
            fdata.append('paket', JSON.stringify(this.formFileUpload.paket))
            fdata.append('urut', this.formFileUpload.urut)
            fdata.append('tipe', this.tipe)
            fdata.append('showVendor', this.formFileUpload.showVendor)
            fdata.append('userId', this.$store.getters['userInfo'].userId)
            if (this.formFileUpload.uploadFilePengumuman) fdata.append('file', this.formFileUpload.uploadFilePengumuman)
            axios.post(apiUrl+"/api/rup/jadwal-private/upload", fdata, { headers: { 'Content-Type': 'multipart/form-data' }})
              .then( (response) => {
                this.formFileUpload.filePengumuman = response.data[0].fileJadwalPrivate;
                this.notification = {
                    show: true,
                    color: "success",
                    text: "Sukses upload file Pengumuman"
                };
              })
              .catch( (error) => {
                  this.notification = {
                      show: true,
                      color: "error",
                      text: `[${error.message}] Gagal upload`
                  }
              });
        }
    }
}
</script>           